import {Report} from '@/modules/neodash/model/types/interfaces/Report';

export interface stateListReports {
  lstReports: Report[],
  isLoadingListReports: boolean;
}

export const defaultAuthenticationState: stateListReports = {
  lstReports: [],
  isLoadingListReports: false
};

export const state = defaultAuthenticationState;
